import {
  Button,
  Menu,
  MenuButton,
  MenuList,
  useDisclosure
} from "@chakra-ui/react";
import React, { useRef, useEffect, useCallback } from "react";
import { ChevronDownIcon } from "@chakra-ui/icons";
import { MenuItem, MenuItemSubMenu } from ".";

function addEL(ref, event, handler) {
  if (ref) ref.addEventListener(event, handler);
}
function remEL(ref, event, handler) {
  if (ref) ref.removeEventListener(event, handler);
}

const InnerMenu = ({ title, childrenItems }) => {
  const refSubMenuButton = useRef();
  const refSubMenuList = useRef();

  const { isOpen, onOpen, onClose } = useDisclosure();

  const subMenuButtonEnterHandle = useCallback(() => {
    onOpen();
    // fix bug with list animation
    refSubMenuList.current.style.pointerEvents = "auto";
  }, [onOpen]);
  const subMenuButtonLeaveHandle = useCallback(() => {
    onClose();
  }, [onClose]);

  // fix bug with list animation,
  // hide it when menu closed and open only if button menu is hovered
  useEffect(() => {
    if (!isOpen) {
      refSubMenuList.current.style.pointerEvents = "none";
    // eslint-disable-next-line no-empty
    } else {
    }
  }, [isOpen]);

  useEffect(() => {
    addEL(refSubMenuButton.current, "mouseenter", subMenuButtonEnterHandle);
    addEL(refSubMenuList.current, "mouseenter", subMenuButtonEnterHandle);
    addEL(refSubMenuButton.current, "mouseleave", subMenuButtonLeaveHandle);
    addEL(refSubMenuList.current, "mouseleave", subMenuButtonLeaveHandle);

    return () => {
      remEL(refSubMenuButton.current, "mouseenter", subMenuButtonEnterHandle);
      remEL(refSubMenuList.current, "mouseenter", subMenuButtonEnterHandle);
      remEL(refSubMenuButton.current, "mouseleave", subMenuButtonLeaveHandle);
      remEL(refSubMenuList.current, "mouseleave", subMenuButtonLeaveHandle);
    };
  }, [subMenuButtonEnterHandle, subMenuButtonLeaveHandle]);

  return (
    <Menu autoSelect={false} offset={[0, 0]} isOpen={isOpen} placement="right">
      <MenuButton
        ref={refSubMenuButton}
        rightIcon={<ChevronDownIcon />}
        as={Button}
        w="full"
        textAlign="left"
        borderRadius="none"
        bg="white"
        zIndex={999}
        _hover={{
          bg: "blue.50"
        }}
        _focus={{
          boxShadow: "none"
        }}
        _expanded={{
          bg: "blue.300",
          color: "white"
        }}
      >
        {title}
      </MenuButton>
      <MenuList
        minW={0}
        ref={refSubMenuList}
        zIndex={999}
        _hover={{ zIndex: 1000 }}
      >
        {childrenItems.map((item, i) => {
          if (typeof item === "string") {
            return <MenuItem key={item}>{item}</MenuItem>;
          }
          return <MenuItemSubMenu key={item}>{item}</MenuItemSubMenu>;
        })}
      </MenuList>
    </Menu>
  );
};

export default InnerMenu;
